import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { shopCategories, shopProducts } from '../data/shopData';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight, FiZap } from 'react-icons/fi';

const CatalogHeader = () => {
  const [activeTab, setActiveTab] = useState('all');
  
  const filtered = shopProducts.filter(p => activeTab === 'all' || p.category === activeTab);

  return (
    <div className="bg-zinc-950 border-b border-zinc-800 pt-32 pb-10 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Event Promo Bar */}
        <div className="bg-gradient-to-r from-red-600 via-red-500 to-red-600 p-4 rounded-2xl mb-12 flex flex-col md:flex-row items-center justify-between gap-4 shadow-xl shadow-red-900/10 border border-red-400/30">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 p-2 rounded-full animate-pulse">
              <SafeIcon icon={FiZap} className="text-white text-xl" />
            </div>
            <div>
              <h4 className="text-white font-black uppercase text-sm leading-none">Business English Workshop 2026</h4>
              <p className="text-red-50 text-xs mt-1 font-bold">5 Enero - 17 Marzo | Mejor comunicación oral en negocios</p>
            </div>
          </div>
          <Link to="/p/workshop-ingles-negocios-2026" className="bg-white text-red-600 px-6 py-2 rounded-full font-black uppercase text-xs hover:bg-zinc-100 transition-all flex items-center gap-2">
            Inscribirse <FiArrowRight />
          </Link>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-10">
          <div>
            <h2 className="text-3xl md:text-5xl font-black text-white uppercase italic tracking-tighter leading-none mb-2">
              Explora Nuestro <span className="text-yellow-500">Campus</span>
            </h2>
            <p className="text-gray-500 font-bold uppercase text-xs tracking-widest">Navegación Rápida de Programas</p>
          </div>
          
          <div className="flex flex-wrap gap-2 justify-center">
            {shopCategories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveTab(cat.id)}
                className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all border ${activeTab === cat.id ? 'bg-white text-black border-white' : 'bg-zinc-900 text-gray-500 border-zinc-800 hover:border-zinc-700'}`}
              >
                <div className="flex items-center gap-2">
                  <SafeIcon icon={cat.icon} />
                  {cat.name}
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="flex overflow-x-auto gap-4 pb-6 no-scrollbar snap-x">
          {filtered.map((product) => (
            <Link 
              key={product.id} 
              to={`/p/${product.slug}`}
              className="min-w-[280px] md:min-w-[320px] bg-zinc-900 border border-zinc-800 p-6 rounded-3xl snap-start group hover:border-yellow-500/50 transition-all relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 bg-zinc-800 px-3 py-1 rounded-bl-xl text-[8px] font-black text-gray-400 uppercase tracking-widest">
                {product.level}
              </div>
              <div className="w-12 h-12 bg-black rounded-2xl flex items-center justify-center text-white mb-4 group-hover:scale-110 transition-transform">
                <SafeIcon icon={product.icon} className="text-2xl" />
              </div>
              <h3 className="text-lg font-black text-white uppercase mb-1 leading-tight">{product.title}</h3>
              <p className="text-gray-500 text-[10px] mb-4 line-clamp-1">{product.description}</p>
              <div className="flex items-baseline gap-2">
                <span className="text-2xl font-black text-green-400">
                  {product.priceUsd === 0 ? 'GRATIS' : `$${product.priceUsd}`}
                </span>
                <span className="text-[10px] text-gray-600 font-bold uppercase">USD</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CatalogHeader;